import { useEffect, useState } from "react";
import {
  FALLBACK_TICKER,
  fetchLiveTicker,
} from "../../utils/liveMarket";
import "./Ticker.css";

export default function Ticker() {
  const [items, setItems] = useState(FALLBACK_TICKER);
  const [live, setLive] = useState(false);
  const [updatedAt, setUpdatedAt] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const { items: next, updatedAt: ts } = await fetchLiveTicker();
        if (cancelled) return;
        setItems(next);
        setUpdatedAt(ts);
        setLive(next.some((i) => i.val !== "—"));
      } catch (err) {
        console.warn("Live ticker error:", err);
      }
    };

    load();
    const id = setInterval(load, 3 * 60 * 1000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  const track = [...items, ...items];
  const timeLabel = updatedAt
    ? new Date(updatedAt).toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
      })
    : null;

  return (
    <div
      className="home-ticker"
      role="region"
      aria-label={`Market ticker${live ? " live prices" : ""}`}
    >
      <div className="home-ticker-badge" title={timeLabel ? `Updated ${timeLabel}` : ""}>
        <span className={`home-ticker-dot ${live ? "is-live" : ""}`} />
        {live ? "LIVE" : "MKT"}
      </div>
      <div className="home-ticker-track">
        {track.map((item, i) => (
          <div className="home-tk" key={`${item.lbl}-${i}`}>
            <span className="lbl">{item.lbl}</span>
            <b>{item.val}</b>
            <span className={item.up ? "up" : "down"}>{item.chg}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
